var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2474_287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0.248291C5.61553 0.248291 4.26216 0.658834 3.11101 1.428C1.95987 2.19717 1.06266 3.29042 0.532846 4.56951C0.003033 5.84859 -0.13559 7.25606 0.134506 8.61392C0.404603 9.97179 1.07129 11.2191 2.05026 12.198C3.02922 13.177 4.2765 13.8437 5.63437 14.1138C6.99224 14.3839 8.3997 14.2453 9.67879 13.7154C10.9579 13.1856 12.0511 12.2884 12.8203 11.1373C13.5895 9.98614 14 8.63276 14 7.24829C13.998 5.39239 13.2599 3.61308 11.9475 2.30076C10.6352 0.988441 8.8559 0.250298 7 0.248291ZM7 13.0816C5.84628 13.0816 4.71846 12.7395 3.75918 12.0985C2.79989 11.4576 2.05222 10.5465 1.61071 9.48061C1.16919 8.41471 1.05368 7.24182 1.27876 6.11026C1.50384 4.97871 2.05941 3.93931 2.87521 3.1235C3.69102 2.3077 4.73042 1.75212 5.86198 1.52704C6.99353 1.30196 8.16642 1.41748 9.23232 1.85899C10.2982 2.30051 11.2093 3.04818 11.8502 4.00746C12.4912 4.96675 12.8333 6.09457 12.8333 7.24829C12.8316 8.79487 12.2165 10.2776 11.1229 11.3712C10.0293 12.4648 8.54658 13.0799 7 13.0816Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9987 6.08179H6.41536C6.26065 6.08179 6.11228 6.14325 6.00289 6.25264C5.89349 6.36204 5.83203 6.51041 5.83203 6.66512C5.83203 6.81983 5.89349 6.9682 6.00289 7.0776C6.11228 7.187 6.26065 7.24845 6.41536 7.24845H6.9987V10.7485C6.9987 10.9032 7.06016 11.0515 7.16955 11.1609C7.27895 11.2703 7.42732 11.3318 7.58203 11.3318C7.73674 11.3318 7.88511 11.2703 7.99451 11.1609C8.10391 11.0515 8.16536 10.9032 8.16536 10.7485V7.24845C8.16536 6.93903 8.04245 6.64229 7.82366 6.4235C7.60486 6.2047 7.30812 6.08179 6.9987 6.08179Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4.91504C7.48325 4.91504 7.875 4.52329 7.875 4.04004C7.875 3.55679 7.48325 3.16504 7 3.16504C6.51675 3.16504 6.125 3.55679 6.125 4.04004C6.125 4.52329 6.51675 4.91504 7 4.91504Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2474_287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.248291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.02728710cf731e6c945a34acab76eb40.svg";
export { ForwardRef as ReactComponent };